import {useEffect} from "react";

const Service = () => {

  const handleParams = (params) => {
    if (params.has("profile")) {
      const profile = params.get("profile");
      localStorage.setItem("agentId", profile);
    }

    if (params.has("orientation")) {
      const orientation = params.get("orientation");
      localStorage.setItem("branchId", orientation);
    }

    localStorage.setItem("lastClicked", "person_service");
  };

  useEffect(() => {
    const url = window.location.search;
    let params = new URLSearchParams(url);

    handleParams(params);

    const checkLocalStorage = () => {
      return (
        localStorage.getItem('agentId') &&
        localStorage.getItem('branchId') &&
        localStorage.getItem('lastClicked')
      );
    };

    const interval = setInterval(() => {
      if (checkLocalStorage()) {
        clearInterval(interval);

        let isLoggedIn = false;
        if (localStorage.getItem('userInfo') && localStorage.getItem('expiration') && localStorage.getItem('token')) {
          isLoggedIn = true;
        }

        if (isLoggedIn) {
          window.location.href = "/";
        } else {
          window.location.href = "/login";
        }
      }
    }, 100);

    return () => clearInterval(interval);

  }, []);

};

export default Service;